/** Lightweight fingerprint to skip redundant overview state updates. */
export function stationOverviewFingerprint(data: unknown): string {
	if (!data || typeof data !== "object") {
		return "";
	}

	const overview = data as {
		event?: { id?: string };
		stations?: Array<{
			station?: { id?: string };
			stats?: Record<string, unknown>;
			flagbags?: Array<{ id?: string; status?: string }>;
		}>;
	};

	return JSON.stringify({
		eventId: overview.event?.id ?? null,
		stations: (overview.stations ?? []).map((s) => ({
			id: s.station?.id ?? null,
			stats: s.stats ?? null,
			flagbags: (s.flagbags ?? []).map((f) => `${f.id}:${f.status}`),
		})),
	});
}

export function isSameStationOverview(a: unknown, b: unknown): boolean {
	return stationOverviewFingerprint(a) === stationOverviewFingerprint(b);
}
